@if(isModalOpen()){
    @for(modal of modalService.modals(); track $index; let last = $last){
      <div [@enterAnimation] 
      class="modals-wrapper" 
      [ngStyle]="{'z-index': 'calc(var(--overlay-z-index) + '+($index+1)+')'}" 
      [ngClass]="{ 'with-header': isWithHeader(modal.name), 'bottom-align': isWithBottomAlign(modal.name), 'no-pointer-events': modal.name === modalName.OrderTreeNotification}"
      tabindex="-1"
      role="dialog"
      cdkTrapFocus
      [attr.aria-modal]="last ? 'true' : 'false'"
      [attr.aria-label]="modal.name"
      [attr.aria-hidden]="!last ? 'true' : null"
      [attr.inert]="!last ? '' : null"
      #modalContainer
      >
        <div
        cdkFocusRegionStart
        class="modals-content"
        [ngClass]="getModalClassAnimation(modal.name)"
        [ngStyle]="{
            'z-index': 'calc(var(--modal-content-z-index) + '+($index+2)+')',
            'max-width': modal.name === modalName.SMSOffer && stateForModal(modalName.SMSOffer)?.coupon?.coupon.imageUrl ? '820px' : '',
        }"
        >

        @switch(modal.name){
          @case(modalName.OrderDetails){
            <cwo-order-details-modal />
          }
          @case(modalName.MobileSideNav){
            <cwo-mobile-nav-menu/>
          }
          @case(modalName.Cart){
            <cwo-cart/>
          }
          @case(modalName.ItemEditor){
            <cwo-item-editor/>
          }
          @case(modalName.SpecialItemEditor){
            <cwo-special-item-editor/>
          }
          @case(modalName.SignIn){
            <cwo-signing-modal />
          }
          @case(modalName.EditWallet){
            <cwo-edit-wallet-modal />
          }
          @case(modalName.AddWallet){
            <cwo-add-wallet-modal />
          }
          @case(modalName.EditAddress){
            <cwo-edit-address-modal/>
          }
          @case(modalName.AddAddress){
            <cwo-add-address-modal />
          }
          @case(modalName.AddCoupon){
            <cwo-add-coupon-modal/>
          }
          @case(modalName.VerifyEmail){
            <cwo-verify-email-modal/>
          }
          @case(modalName.CouponConfirmation){
            <cwo-coupon-confirmation-modal [couponConfirmationInstructionsModalTemplateRef]="couponConfirmationInstructionsModalTemplateRef()"/>
          }
          @case(modalName.ImagePreview){
            <cwo-image-preview-modal class="image-preview-content"/>
          }
          @case(modalName.OrderTreeNotification){
            <cwo-order-tree-notification-modal />
          }
          @case(modalName.Generic){
            <cwo-generic-modals class="generic-modal" />
          }
          @case(modalName.SMSOffer){
            <cwo-sms-offer-modal />
          }
          @case(modalName.SurveySubmittedLinks){
            <cwo-completed-survey-modal />
          }
          @case(modalName.ForcedChoice){
            <cwo-forced-choice-modals />
          }
          @case(modalName.FundraiserSponsors){
            <cwo-fundraiser-sponsors-modal></cwo-fundraiser-sponsors-modal>
          }
          @case(modalName.CancelSubscription){
            <cwo-cancel-subscription-modal />
          }
          @case(modalName.ReactivateSubscription){
            <cwo-reactivate-subscription-modal />
          }
          @case(modalName.EnjoySurvey){
            <cwo-modal-survey-checkout />
          }
        }
      </div>
      @if(modal.name !== modalName.OrderTreeNotification && modal.name !== modalName.EnjoySurvey){
        <div class="overlay-background" (click)="handleBackdropClick(modal.name)" (keydown)="handleEscapeKey()" aria-hidden="true"></div>
      }
      @if(modal.name === modalName.EnjoySurvey){
        <div class="overlay-background" aria-hidden="true"></div>
      }
    </div>
    }
  }
  
  <ng-template #couponConfirmationInstructionsModal>
    <div class="coupon-confirmation-container">
      <span class="pending-special-name">{{orderService.order().pendingSpecial?.name}}</span>
      <span class="pending-special-instructions">{{orderService.order().pendingSpecial?.instructions}}</span>
    </div>
  </ng-template>
